import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppFacadeService } from '../../services/app-facade.service';

@Component({
    standalone: false,
    selector: 'por-contract-instructions',
    templateUrl: './contract-instructions.component.html',
    styleUrls: ['./contract-instructions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractInstructionsComponent {
    readonly appFacadeService = inject(AppFacadeService);

    overlayStates = {
        payMultipleContract: false,
        paySingleContract: false,
        viewContractDetail: false
    };

    toggleOverlay(overlay: keyof typeof this.overlayStates) {
        this.overlayStates[overlay] = !this.overlayStates[overlay];
    }
}
